import { apiClient } from '@/services/api/client';

import type { TourId } from '@/services/appEvents';

const ACTIVITY_URL = '/api/account/activity/';

/**
 * Every event the app records against the user's account on the backend, with the
 * properties it carries. Unlike analytics, these are kept regardless of consent.
 */
interface BackendEvent {
  tour_completed: { tour: TourId };
  tour_skipped: { tour: TourId; step?: string };
}

export async function sendBackendEvent<E extends keyof BackendEvent>(
  event: E,
  properties: BackendEvent[E]
): Promise<void> {
  await apiClient.post(ACTIVITY_URL, { event, ...properties });
}
